export const iconFontAwesomeCodingMicrochip = (
	<i className="fa-solid fa-microchip"></i>
);
